export enum QuestionAlertsType {
  Your,
  All,
}

export const questionAlertTypes = (isQuestionManager: boolean) => [
  {
    name: QuestionAlertsType.All,
    label: `All ${ isQuestionManager ? '' : 'Shared ' }Questions`,
  },
  {
    name: QuestionAlertsType.Your,
    label: 'Your Questions Only',
  },
];
